// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantDemographicsInfoDto
 */
export interface IParticipantDemographicsInfoDto {
    /**
     * Required if organization idSource is SSN
     * @type {string}
     * @memberof IParticipantDemographicsInfoDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantDemographicsInfoDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantDemographicsInfoDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantDemographicsInfoDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantDemographicsInfoDto
     */
    suffix?: string;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantDemographicsInfoDto
     * @deprecated
     */
    birth_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantDemographicsInfoDto
     */
    local_date_birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IParticipantDemographicsInfoDto
     */
    gender?: IParticipantDemographicsInfoDtoGenderEnum;
}

/**
* @export
* @enum {string}
*/
export enum IParticipantDemographicsInfoDtoGenderEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}


/**
 * Check if a given object implements the IParticipantDemographicsInfoDto interface.
 */
export function instanceOfIParticipantDemographicsInfoDto(value: object): value is IParticipantDemographicsInfoDto {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function IParticipantDemographicsInfoDtoFromJSON(json: any): IParticipantDemographicsInfoDto {
    return IParticipantDemographicsInfoDtoFromJSONTyped(json, false);
}

export function IParticipantDemographicsInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantDemographicsInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'first_name': json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'local_date_birth_on': json['local_date_birth_on'] == null ? undefined : (new Date(json['local_date_birth_on'])),
        'gender': json['gender'] == null ? undefined : json['gender'],
    };
}

export function IParticipantDemographicsInfoDtoToJSON(json: any): IParticipantDemographicsInfoDto {
    return IParticipantDemographicsInfoDtoToJSONTyped(json, false);
}

export function IParticipantDemographicsInfoDtoToJSONTyped(value?: IParticipantDemographicsInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ssn': value['ssn'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString()),
        'local_date_birth_on': value['local_date_birth_on'] == null ? undefined : ((value['local_date_birth_on']).toISOString().substring(0,10)),
        'gender': value['gender'],
    };
}

